export default __webpack_public_path__ + "static/media/Knight_Runner-thumbnail.f3e2a188.jpg";